import { t } from "@lingui/core/macro";

import { VStack, Text } from "@whoosh/design-system/src/components/primitive";

import { PunchPassListItem } from "./PunchPassListItem";
import { PunchPassListItem_PunchPass$key } from "./__generated__/PunchPassListItem_PunchPass.graphql";
import type { PunchPassTemplateType } from "./__generated__/PunchPassListItem_PunchPass.graphql";

export type AvailablePunchPassesSectionItem = {
  ref: PunchPassListItem_PunchPass$key;
  id?: string | null;
  hasSameTypeApplied: boolean;
};

export type AvailablePunchPassesSectionProps = {
  items: readonly AvailablePunchPassesSectionItem[];
  onApply: (id: string, punchPassType?: PunchPassTemplateType) => void;
  onRemove: (id: string) => void;
};

export const AvailablePunchPassesSection = ({
  items,
  onApply,
  onRemove,
}: AvailablePunchPassesSectionProps) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <VStack gap={2} padding={5} backgroundColor="surface-primary">
      <Text
        variant="mainTiny"
        color="text-secondary"
        fontWeight="semibold"
        paddingVertical={1}
      >{t`AVAILABLE`}</Text>
      {items.map((item, index) => (
        <PunchPassListItem
          key={index}
          punchPassRef={item.ref}
          isAvailable={true}
          isApplied={false}
          hasSameTypeApplied={item.hasSameTypeApplied}
          onApply={onApply}
          onRemove={onRemove}
        />
      ))}
    </VStack>
  );
};
